import { usePeople } from '../../api/people';
import { usePatchTask, type TaskDto } from '../../api/tasks';
import { SearchablePickerList } from './_picker-primitives';

export function PersonEditor({ task, onClose }: { task: TaskDto; onClose: () => void }) {
  const patch = usePatchTask();
  const people = usePeople(false);
  const list = people.data?.people ?? [];
  return (
    <SearchablePickerList
      options={list.map((p) => ({ id: p.id, label: p.name, sub: p.role ?? null }))}
      activeId={task.personId}
      allowClear
      onPick={(id) => {
        patch.mutate({ id: task.id, patch: { personId: id } });
        onClose();
      }}
    />
  );
}
